import React, { Component } from 'react';
import { Route } from 'react-router';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faPlusSquare } from '@fortawesome/free-regular-svg-icons'
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { ServiceStatus } from './components/ServiceStatus';
import { DocumentStore } from './components/DocumentStore';

library.add(faCircle, faInfoCircle, faPlusSquare)
export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Route path='/' exact={true} render={(props) => (<Home returnType="HOME" displayName="Home" {...props} />)} />
                <Route path='/SITREP' render={(props) => (<ServiceStatus returnType="SITREP" displayName="SITREP" {...props} />)} />
                <Route path='/ambulancestatus' render={(props) => (<ServiceStatus returnType="AMBULANCE DAILY" displayName="AMBULANCE DAILY" {...props} />)} />
                <Route path='/acutestatus' render={(props) => (<ServiceStatus returnType="ACUTENEARREALTIME" displayName="ACUTE NEAR REALTIME" {...props} />)} />
                <Route path='/ambulancerealstatus' render={(props) => (<ServiceStatus returnType="AMBULANCENEARREALTIME" displayName="AMBULANCE NEAR REALTIME" {...props} />)} />
                <Route path='/jointreporting' render={(props) => (<ServiceStatus returnType="Joint Reporting" displayName="JOINT REPORTING" {...props} />)} />
                <Route path='/covidreporting' render={(props) => (<ServiceStatus returnType="Covid Reporting" displayName="COVID REPORTING" {...props} />)} />
                <Route path='/mhecds' render={(props) => (<ServiceStatus returnType="MHECDS" displayName="MH ECDS" {...props} />)} />
                <Route path='/mhcrisis' render={(props) => (<ServiceStatus returnType="MHCRISIS" displayName="MH CRISIS" {...props} />)} />
                <Route path='/help' render={(props) => (<DocumentStore returnType="Documents" displayName="Guidance Documents" {...props} />)} />
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js